import { Component, Inject, OnInit, ElementRef } from '@angular/core';
import { UntypedFormGroup, FormArray, UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-event-capacity-dialog',
  templateUrl: './event-capacity-dialog.component.html',
  styleUrls: ['./event-capacity-dialog.component.scss']
})
export class EventCapacityDialogComponent implements OnInit {

  venueForm: UntypedFormGroup = new UntypedFormGroup({})
  capacity: number = 0;
  activeStep: number = 1;

  venueId: string = '';
  venueMaxCapacity: number = 0;
  canSetReservationLimit: Boolean = true;

  // labelForReservationCapacityLimit = "Reservation capacity limit";

  constructor(
    private dialogRef: MatDialogRef<EventCapacityDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.venueId = data.venueId
    this.venueMaxCapacity = data.venueMaxCapacity;
    this.capacity = data.venueCapacity;
   }

  ngOnInit(): void {
    this.initForm();
  }

  shareCapacity(value: number) {
    this.capacity = value
  }

  save() {
    this.venueForm.reset();
    this.dialogRef.close(this.capacity);
  }

  close() {
    this.venueForm.reset();
    this.dialogRef.close(false);
  }

  private initForm() {
    let venueId = '';
    let maximumCapacity = 0;
    this.venueForm = new UntypedFormGroup({
      venueId: new UntypedFormControl(venueId,Validators.required),
      maximumCapacity: new UntypedFormControl(maximumCapacity,Validators.required),
    });
  }
}
